
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anonymous-payment",
      function () {
        return require("private-next-pages/anonymous-payment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anonymous-payment"])
      });
    }
  